import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

function UserFilters({
    selectedFilter,
    filterValue,
    onFilterChange,
    onFilterValueChange,
    onApply,
    onClear
}) {
    const numericFilters = ["user_id", "parent"];
    return (
        <Row className="align-items-center">
            {/* Label */}
            <Col md="auto">
                <h6
                    style={{ fontWeight: 600, color: "#333", whiteSpace: "nowrap" }}
                >
                    Filters:
                </h6>
            </Col>

            {/* Select Filter */}
            <Col md="auto">
                <Form.Group>
                    <Form.Select
                        value={selectedFilter}
                        onChange={onFilterChange}
                        name="selectedFilter"
                        className="mt-1"
                    >
                        <option value="">Select options</option>
                        <option value="all">ALL</option>
                        <option value="user_id">User ID</option>
                        <option value="username">Username</option>
                        <option value="parent">Parent Id</option>
                        <option value="parent_user">Parent User Name</option>
                    </Form.Select>
                </Form.Group>
            </Col>

            {/* Input */}
            {selectedFilter && selectedFilter !== "all" && (
                <Col md="auto">
                    <Form.Group>
                        <Form.Control
                        className="mb-3"
                            value={filterValue}
                            placeholder={`Enter ${selectedFilter.replace("_", " ")}`}
                            type={numericFilters.includes(selectedFilter) ? "number" : "text"}
                            inputMode={numericFilters.includes(selectedFilter) ? "numeric" : "text"}
                            onChange={(e) => {
                                const value = e.target.value;

                                if (numericFilters.includes(selectedFilter)) {
                                    if (/^\d*$/.test(value)) {
                                        onFilterValueChange(e);
                                    }
                                } else {
                                    onFilterValueChange(e);
                                }
                            }}
                        />
                    </Form.Group>
                </Col>
            )}

            {selectedFilter &&
                (
                    <>
                        <Col md="auto">
                            <Button className="btn-primary mb-3" onClick={onApply}>
                                Apply
                            </Button>
                        </Col>

                        <Col md="auto">
                            <Button
                                variant="link"
                                className="p-0 ms-2 mb-3 text-decoration-none"
                                onClick={onClear}
                            >
                                Clear
                            </Button>
                        </Col>
                    </>
                )
            }
        </Row>
    );
}

export default UserFilters;
